import { nanoid } from 'nanoid';


import {Client} from "../API";
import {ActionName, isAllowed} from "../access_rights/isAllowed";
import {UserRole} from "../stores/UserSessionState";
import {ClientInApp} from "../shared/types/SubscriptionTypes";


import {getTeamFromURL} from "../utils/url";
import {updateCompany} from "./clientUser/company";
import { CrudServices } from "../platform/services/types/ServiceDependencies";
import { UserSessionState } from "../stores/UserSessionState";
import { RootStoreModel } from "../stores/RootStore";
import { DataSourceManager } from "../stores/dataSources/DataSourceManager";
import {triggerLimitAlert} from "../access_rights/triggerLimitAlert";


import {MODALS} from "../ui/screens/modals/modal-names";
import {AppState} from "@stores/AppState";


export interface InviteInfo {
    link: string;
    team: string;
}


export const getInviteLink = async (dsManager: DataSourceManager) => {
    const client = dsManager.clientAR.row!;
    return getInviteLinkFromClient(client);
}

export const getInviteLinkFromClient = (client: Client | ClientInApp) => {
    return `${import.meta.env.VITE_BASE_URL}${client.slug}?link=${client.inviteLink}`;
}


export const getInviteInfoFromLink = (): InviteInfo | undefined => {
    /* todo think about cases when link to team goes without invite, maybe show request access button */
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.has('link')
        ? {
            link: queryParams.get('link')!,
            team: getTeamFromURL(),
        }
        : undefined;
}

export const resetInviteLink = async (
    services: CrudServices,
    userState: UserSessionState,
    rootStore: RootStoreModel
) => {
    return updateCompany(services, userState, rootStore, {
        inviteLink: nanoid(),
    })
}


export const setInviteLinkUserRole = async (
    services: CrudServices,
    userState: UserSessionState,
    rootStore: RootStoreModel,
    userRole: UserRole
) => {
    return updateCompany(services, userState, rootStore, {
        userRole: userRole,
    })
}

export const inviteUser = (dsManager: DataSourceManager, appState: AppState) => {
    if (isAllowed(dsManager, { actionName: ActionName.InviteUsers })) {
        appState.setModal({name: MODALS.INVITE, params: undefined});
    } else {
        triggerLimitAlert(appState, ActionName.InviteUsers);
    }
};